// Auto-generated resource for Reviews — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const ReviewsKeys = {
  Shell: {
    Title: 'Reviews.Shell.Title',
    BackToReviews: 'Reviews.Shell.BackToReviews',
    Loading: 'Reviews.Shell.Loading',
    Running: 'Reviews.Shell.Running',
    RunningHint: 'Reviews.Shell.RunningHint',
    MissingSessionId: 'Reviews.Shell.MissingSessionId',
    MissingReviewId: 'Reviews.Shell.MissingReviewId',
    FailedToLoad: 'Reviews.Shell.FailedToLoad',
    NoReviewYetHeading: 'Reviews.Shell.NoReviewYetHeading',
    NoReviewYetBody: 'Reviews.Shell.NoReviewYetBody',
    CouldNotLoadHeading: 'Reviews.Shell.CouldNotLoadHeading',
    NotFoundHeading: 'Reviews.Shell.NotFoundHeading',
    NotFoundBody: 'Reviews.Shell.NotFoundBody',
    ForbiddenBody: 'Reviews.Shell.ForbiddenBody',
    TryAgain: 'Reviews.Shell.TryAgain',
  },
  Library: {
    Title: 'Reviews.Library.Title',
    Heading: 'Reviews.Library.Heading',
    Lede: 'Reviews.Library.Lede',
    Loading: 'Reviews.Library.Loading',
    FailedToLoad: 'Reviews.Library.FailedToLoad',
    CouldNotLoadHeading: 'Reviews.Library.CouldNotLoadHeading',
    EmptyHeading: 'Reviews.Library.EmptyHeading',
    EmptyBody: 'Reviews.Library.EmptyBody',
    EmptyCta: 'Reviews.Library.EmptyCta',
    FilterAria: 'Reviews.Library.FilterAria',
    FilterAll: 'Reviews.Library.FilterAll',
    FilterPractice: 'Reviews.Library.FilterPractice',
    FilterStandalone: 'Reviews.Library.FilterStandalone',
    DateFilterAria: 'Reviews.Library.DateFilterAria',
    FilterAnyTime: 'Reviews.Library.FilterAnyTime',
    FilterToday: 'Reviews.Library.FilterToday',
    FilterLast7Days: 'Reviews.Library.FilterLast7Days',
    FilterLast30Days: 'Reviews.Library.FilterLast30Days',
    NoFilterMatch: 'Reviews.Library.NoFilterMatch',
    SourceStandalone: 'Reviews.Library.SourceStandalone',
    SourcePractice: 'Reviews.Library.SourcePractice',
    StatusReady: 'Reviews.Library.StatusReady',
    StatusPending: 'Reviews.Library.StatusPending',
    StatusFailed: 'Reviews.Library.StatusFailed',
    StatusPrefix: 'Reviews.Library.StatusPrefix',
    OneReview: 'Reviews.Library.OneReview',
    ManyReviews: 'Reviews.Library.ManyReviews',
    OpenObservatory: 'Reviews.Library.OpenObservatory',
    DateToday: 'Reviews.Library.DateToday',
    DateYesterday: 'Reviews.Library.DateYesterday',
    DateDaysAgo: 'Reviews.Library.DateDaysAgo',
    DateWeeksAgo: 'Reviews.Library.DateWeeksAgo',
    DateMonthsAgo: 'Reviews.Library.DateMonthsAgo',
    Retry: 'Reviews.Library.Retry',
    RetryError: 'Reviews.Library.RetryError',
    Rereview: 'Reviews.Library.Rereview',
  },
  Discard: {
    Action: 'Reviews.Discard.Action',
    ConfirmTitle: 'Reviews.Discard.ConfirmTitle',
    ConfirmBody: 'Reviews.Discard.ConfirmBody',
    Confirm: 'Reviews.Discard.Confirm',
    Cancel: 'Reviews.Discard.Cancel',
    Discarded: 'Reviews.Discard.Discarded',
    Error: 'Reviews.Discard.Error',
  },
  Observatory: {
    Heading: 'Reviews.Observatory.Heading',
    SaveAsPdf: 'Reviews.Observatory.SaveAsPdf',
    StatusAria: 'Reviews.Observatory.StatusAria',
    LabelReviewed: 'Reviews.Observatory.LabelReviewed',
    LabelNoRecording: 'Reviews.Observatory.LabelNoRecording',
    LabelPending: 'Reviews.Observatory.LabelPending',
    LabelFailed: 'Reviews.Observatory.LabelFailed',
    PendingNotice: 'Reviews.Observatory.PendingNotice',
    Refresh: 'Reviews.Observatory.Refresh',
    FailedNotice: 'Reviews.Observatory.FailedNotice',
    RecordingEvictedNotice: 'Reviews.Observatory.RecordingEvictedNotice',
    NoRecordingAria: 'Reviews.Observatory.NoRecordingAria',
    NoRecordingBody: 'Reviews.Observatory.NoRecordingBody',
    VoiceAnalyticsUnavailable: 'Reviews.Observatory.VoiceAnalyticsUnavailable',
    ConfigDepth: 'Reviews.Observatory.ConfigDepth',
    ConfigLenses: 'Reviews.Observatory.ConfigLenses',
    ConfigLensesNone: 'Reviews.Observatory.ConfigLensesNone',
    FrameQuarter: 'Reviews.Observatory.FrameQuarter',
    FrameHalf: 'Reviews.Observatory.FrameHalf',
    FrameFull: 'Reviews.Observatory.FrameFull',
    ConfigAria: 'Reviews.Observatory.ConfigAria',
    MoreActions: 'Reviews.Observatory.MoreActions',
    SummaryHeading: 'Reviews.Observatory.SummaryHeading',
    SummaryEmpty: 'Reviews.Observatory.SummaryEmpty',
  },
  Upload: {
    UploadRecordingAria: 'Reviews.Upload.UploadRecordingAria',
    GetAiReview: 'Reviews.Upload.GetAiReview',
    GetAiReviewAria: 'Reviews.Upload.GetAiReviewAria',
    ReviewAgainAria: 'Reviews.Upload.ReviewAgainAria',
    Uploading: 'Reviews.Upload.Uploading',
    RequestingUrl: 'Reviews.Upload.RequestingUrl',
    UploadingRecording: 'Reviews.Upload.UploadingRecording',
    Processing: 'Reviews.Upload.Processing',
    RequestingReview: 'Reviews.Upload.RequestingReview',
    Complete: 'Reviews.Upload.Complete',
    ReviewAgain: 'Reviews.Upload.ReviewAgain',
    UploadRecording: 'Reviews.Upload.UploadRecording',
    Offline: 'Reviews.Upload.Offline',
    PleaseSignIn: 'Reviews.Upload.PleaseSignIn',
    NotPermitted: 'Reviews.Upload.NotPermitted',
    InvalidRequest: 'Reviews.Upload.InvalidRequest',
    ServiceUnavailable: 'Reviews.Upload.ServiceUnavailable',
    Failed: 'Reviews.Upload.Failed',
    NeedCredits: 'Reviews.Upload.NeedCredits',
  },
  Quality: {
    LoadingOptions: 'Reviews.Quality.LoadingOptions',
    LoadError: 'Reviews.Quality.LoadError',
    ModelGroupLabel: 'Reviews.Quality.ModelGroupLabel',
    RecommendedBadge: 'Reviews.Quality.RecommendedBadge',
    FrameGroupLabel: 'Reviews.Quality.FrameGroupLabel',
    BalanceOne: 'Reviews.Quality.BalanceOne',
    BalanceMany: 'Reviews.Quality.BalanceMany',
    BalanceBreakdown: 'Reviews.Quality.BalanceBreakdown',
    NotEnoughCreditsBalance: 'Reviews.Quality.NotEnoughCreditsBalance',
    TopUp: 'Reviews.Quality.TopUp',
    HighCostConfirmLabel: 'Reviews.Quality.HighCostConfirmLabel',
    TierBalanced: 'Reviews.Quality.TierBalanced',
    TierDeeper: 'Reviews.Quality.TierDeeper',
    TierDeepest: 'Reviews.Quality.TierDeepest',
    TierCustom: 'Reviews.Quality.TierCustom',
    TierCostOne: 'Reviews.Quality.TierCostOne',
    TierCostMany: 'Reviews.Quality.TierCostMany',
    ModelOptionRecommended: 'Reviews.Quality.ModelOptionRecommended',
  },
  Dialog: {
    Title: 'Reviews.Dialog.Title',
    Subtitle: 'Reviews.Dialog.Subtitle',
    CloseAria: 'Reviews.Dialog.CloseAria',
    DepthLegend: 'Reviews.Dialog.DepthLegend',
    DepthHelpBalanced: 'Reviews.Dialog.DepthHelpBalanced',
    DepthHelpDeeper: 'Reviews.Dialog.DepthHelpDeeper',
    DepthHelpDeepest: 'Reviews.Dialog.DepthHelpDeepest',
    DepthHelpCustom: 'Reviews.Dialog.DepthHelpCustom',
    YourMix: 'Reviews.Dialog.YourMix',
    CustomAria: 'Reviews.Dialog.CustomAria',
    Optional: 'Reviews.Dialog.Optional',
    Cancel: 'Reviews.Dialog.Cancel',
    Request: 'Reviews.Dialog.Request',
    RequestOne: 'Reviews.Dialog.RequestOne',
  },
  Frameworks: {
    OverlayAria: 'Reviews.Frameworks.OverlayAria',
    ReferenceLabel: 'Reviews.Frameworks.ReferenceLabel',
    NoneOption: 'Reviews.Frameworks.NoneOption',
    LensPickerAria: 'Reviews.Frameworks.LensPickerAria',
    LensPickerLegend: 'Reviews.Frameworks.LensPickerLegend',
    LensNudge: 'Reviews.Frameworks.LensNudge',
  },
  Clarity: {
    FillerTotal: 'Reviews.Clarity.FillerTotal',
    FillerPerMinute: 'Reviews.Clarity.FillerPerMinute',
    NonWords: 'Reviews.Clarity.NonWords',
    FillerPhrases: 'Reviews.Clarity.FillerPhrases',
    RecognitionConfidenceLabel: 'Reviews.Clarity.RecognitionConfidenceLabel',
    RecognitionConfidenceHelp: 'Reviews.Clarity.RecognitionConfidenceHelp',
    RecognitionConfidenceShort: 'Reviews.Clarity.RecognitionConfidenceShort',
  },
  Pronunciation: {
    OptionLabel: 'Reviews.Pronunciation.OptionLabel',
    OptionHint: 'Reviews.Pronunciation.OptionHint',
    AccentLabel: 'Reviews.Pronunciation.AccentLabel',
    AccentUsEnglish: 'Reviews.Pronunciation.AccentUsEnglish',
    AccentBritishEnglish: 'Reviews.Pronunciation.AccentBritishEnglish',
    SectionHeading: 'Reviews.Pronunciation.SectionHeading',
    SectionAria: 'Reviews.Pronunciation.SectionAria',
    HeardLabel: 'Reviews.Pronunciation.HeardLabel',
    SayLabel: 'Reviews.Pronunciation.SayLabel',
    OccurrenceOne: 'Reviews.Pronunciation.OccurrenceOne',
    OccurrenceMany: 'Reviews.Pronunciation.OccurrenceMany',
    ConfigPronunciation: 'Reviews.Pronunciation.ConfigPronunciation',
  },
  Tracks: {
    Aria: 'Reviews.Tracks.Aria',
    Empty: 'Reviews.Tracks.Empty',
    AuditoryName: 'Reviews.Tracks.AuditoryName',
    AuditorySub: 'Reviews.Tracks.AuditorySub',
    VisualName: 'Reviews.Tracks.VisualName',
    VisualSub: 'Reviews.Tracks.VisualSub',
    ContentName: 'Reviews.Tracks.ContentName',
    ContentSub: 'Reviews.Tracks.ContentSub',
    ClarityName: 'Reviews.Tracks.ClarityName',
    ClaritySub: 'Reviews.Tracks.ClaritySub',
    ArchetypeName: 'Reviews.Tracks.ArchetypeName',
    ArchetypeSub: 'Reviews.Tracks.ArchetypeSub',
    CuesName: 'Reviews.Tracks.CuesName',
    CuesSub: 'Reviews.Tracks.CuesSub',
    PronunciationName: 'Reviews.Tracks.PronunciationName',
    PronunciationSub: 'Reviews.Tracks.PronunciationSub',
    TranscriptName: 'Reviews.Tracks.TranscriptName',
    TranscriptSub: 'Reviews.Tracks.TranscriptSub',
    LegendPitch: 'Reviews.Tracks.LegendPitch',
    LegendVolume: 'Reviews.Tracks.LegendVolume',
    LegendPace: 'Reviews.Tracks.LegendPace',
    LegendPauses: 'Reviews.Tracks.LegendPauses',
    LegendAria: 'Reviews.Tracks.LegendAria',
    AuditoryAria: 'Reviews.Tracks.AuditoryAria',
    Sequence: 'Reviews.Tracks.Sequence',
  },
  ObservationsPanel: {
    Heading: 'Reviews.ObservationsPanel.Heading',
    Follow: 'Reviews.ObservationsPanel.Follow',
    ShowAll: 'Reviews.ObservationsPanel.ShowAll',
    ShowFewer: 'Reviews.ObservationsPanel.ShowFewer',
    ExpandAll: 'Reviews.ObservationsPanel.ExpandAll',
    Empty: 'Reviews.ObservationsPanel.Empty',
    RowAria: 'Reviews.ObservationsPanel.RowAria',
  },
  FrameworkFit: {
    Heading: 'Reviews.FrameworkFit.Heading',
    Intro: 'Reviews.FrameworkFit.Intro',
  },
  Effort: {
    Legend: 'Reviews.Effort.Legend',
    Help: 'Reviews.Effort.Help',
    Minimal: 'Reviews.Effort.Minimal',
    Low: 'Reviews.Effort.Low',
    Medium: 'Reviews.Effort.Medium',
    High: 'Reviews.Effort.High',
    Snapped: 'Reviews.Effort.Snapped',
    ChargeNote: 'Reviews.Effort.ChargeNote',
    RequestUpTo: 'Reviews.Effort.RequestUpTo',
  },
} as const;

export const ReviewsValues = {
  'default': {
    'Clarity.FillerPerMinute': '{Rate}/min',
    'Clarity.FillerPhrases': 'Filler phrases ({Count}):',
    'Clarity.FillerTotal': '{Count} fillers total',
    'Clarity.NonWords': 'Non-words ({Count}):',
    'Clarity.RecognitionConfidenceHelp': 'How confidently speech recognition matched the words in this take. Use it to compare your own reps of the same script — unusual words and accents lower it, so it is not a pronunciation, accent, or intelligibility score.',
    'Clarity.RecognitionConfidenceLabel': 'Recognition confidence',
    'Clarity.RecognitionConfidenceShort': 'compare your own reps, not a score',
    'Dialog.Cancel': 'Cancel',
    'Dialog.CloseAria': 'Close',
    'Dialog.CustomAria': 'Custom review settings',
    'Dialog.DepthHelpBalanced': 'Balanced: a thorough read of the whole take — the everyday choice.',
    'Dialog.DepthHelpCustom': 'Custom: pick the review model and how much body-language detail it sees.',
    'Dialog.DepthHelpDeeper': 'Deeper: a stronger reviewer that picks up subtler patterns in your voice and delivery.',
    'Dialog.DepthHelpDeepest': 'Deepest: our most capable reviewer, for the takes that matter most.',
    'Dialog.DepthLegend': 'How deep?',
    'Dialog.Optional': 'optional',
    'Dialog.Request': 'Request review',
    'Dialog.RequestOne': 'Request review · {Credits} credit',
    'Dialog.Subtitle': 'Observations on your voice, body language, content and clarity — never a score.',
    'Dialog.Title': 'Get an AI Review',
    'Dialog.YourMix': 'your mix',
    'Discard.Action': 'Discard review',
    'Discard.Cancel': 'Cancel',
    'Discard.Confirm': 'Discard',
    'Discard.ConfirmBody': 'This deletes the review only — your recording and practice session are untouched. This can’t be undone.',
    'Discard.ConfirmTitle': 'Discard this AI Review?',
    'Discard.Discarded': 'Review discarded.',
    'Discard.Error': 'Couldn’t discard this review. Please try again.',
    'Effort.ChargeNote': 'You pay what it actually costs — never more than the maximum shown.',
    'Effort.Help': 'How hard the model thinks before it answers. More effort can catch subtler things, and costs more.',
    'Effort.High': 'Thorough',
    'Effort.Legend': 'Effort',
    'Effort.Low': 'Light',
    'Effort.Medium': 'Careful',
    'Effort.Minimal': 'Quick',
    'Effort.RequestUpTo': 'Request review · up to {Credits} credits',
    'Effort.Snapped': '{Model} doesn’t offer {Wanted} — set to {Effort}.',
    'FrameworkFit.Heading': 'Framework fit',
    'FrameworkFit.Intro': 'How this take sits against the lenses you chose — observations, not scores.',
    'Frameworks.LensNudge': 'Focusing on one or two lenses usually helps more than ticking everything — pick the ones that match this take.',
    'Frameworks.LensPickerAria': 'Framework review lenses',
    'Frameworks.LensPickerLegend': 'Framework lenses',
    'Frameworks.NoneOption': 'None',
    'Frameworks.OverlayAria': 'Framework reference',
    'Frameworks.ReferenceLabel': 'Framework reference',
    'Library.CouldNotLoadHeading': 'Couldn’t load your reviews',
    'Library.DateDaysAgo': '{Days} days ago',
    'Library.DateFilterAria': 'Filter reviews by date',
    'Library.DateMonthsAgo': '{Months} mo ago',
    'Library.DateToday': 'today',
    'Library.DateWeeksAgo': '{Weeks} wk ago',
    'Library.DateYesterday': 'yesterday',
    'Library.EmptyBody': 'Record a take in any practice — Playground or Mastery — and send it to AI Review. It’ll show up here.',
    'Library.EmptyCta': 'Start a practice',
    'Library.EmptyHeading': 'No AI Reviews yet',
    'Library.FailedToLoad': 'Failed to load your reviews.',
    'Library.FilterAll': 'All',
    'Library.FilterAnyTime': 'Any time',
    'Library.FilterAria': 'Filter reviews',
    'Library.FilterLast30Days': 'Last 30 days',
    'Library.FilterLast7Days': 'Last 7 days',
    'Library.FilterPractice': 'Practice-linked',
    'Library.FilterStandalone': 'Standalone',
    'Library.FilterToday': 'Today',
    'Library.Heading': 'AI Reviews',
    'Library.Lede': 'Every take you’ve sent to AI Review — practice sessions and standalone uploads.',
    'Library.Loading': 'Loading your reviews…',
    'Library.ManyReviews': '{Count} reviews',
    'Library.NoFilterMatch': 'No reviews match this filter.',
    'Library.OneReview': '1 review',
    'Library.OpenObservatory': 'Open Observatory',
    'Library.Rereview': 'Re-review',
    'Library.Retry': 'Re-review',
    'Library.RetryError': 'Couldn’t start a re-review. Please try again.',
    'Library.SourcePractice': 'Practice',
    'Library.SourceStandalone': 'Standalone upload',
    'Library.StatusFailed': 'Failed',
    'Library.StatusPending': 'Pending',
    'Library.StatusPrefix': 'Status: {Status}',
    'Library.StatusReady': 'Ready',
    'Library.Title': 'Your AI Reviews · VoiceDojo',
    'ObservationsPanel.Empty': 'No observations for this take.',
    'ObservationsPanel.ExpandAll': 'Expand all',
    'ObservationsPanel.Follow': 'Follow the replay',
    'ObservationsPanel.Heading': 'Observations',
    'ObservationsPanel.RowAria': 'Observation at {Time}: {Summary}',
    'ObservationsPanel.ShowAll': 'Show all observations',
    'ObservationsPanel.ShowFewer': 'Show fewer',
    'Observatory.ConfigAria': 'Review configuration',
    'Observatory.ConfigDepth': 'Depth',
    'Observatory.ConfigLenses': 'Lenses',
    'Observatory.ConfigLensesNone': 'None',
    'Observatory.FailedNotice': 'We couldn’t analyse this recording.',
    'Observatory.FrameFull': 'Full',
    'Observatory.FrameHalf': 'Half',
    'Observatory.FrameQuarter': 'Quarter',
    'Observatory.Heading': 'Voice Observatory',
    'Observatory.LabelFailed': 'Failed',
    'Observatory.LabelNoRecording': 'No recording',
    'Observatory.LabelPending': 'Pending',
    'Observatory.LabelReviewed': 'Reviewed',
    'Observatory.MoreActions': 'More actions',
    'Observatory.NoRecordingAria': 'No recording for playback',
    'Observatory.NoRecordingBody': 'No recording is associated with this review.',
    'Observatory.PendingNotice': 'Reviewing your recording… The AI coach is observing your take. This refreshes automatically when it lands.',
    'Observatory.RecordingEvictedNotice': 'Recording is no longer available — voice analysis from this review is preserved below.',
    'Observatory.Refresh': 'Refresh',
    'Observatory.SaveAsPdf': 'Save as PDF',
    'Observatory.StatusAria': 'Status: {Status}',
    'Observatory.SummaryEmpty': 'No closing summary was generated for this take.',
    'Observatory.SummaryHeading': 'What stood out',
    'Observatory.VoiceAnalyticsUnavailable': 'Voice analytics were unavailable for this take.',
    'Pronunciation.AccentBritishEnglish': 'British English',
    'Pronunciation.AccentLabel': 'Reference accent',
    'Pronunciation.AccentUsEnglish': 'US English',
    'Pronunciation.ConfigPronunciation': 'Pronunciation',
    'Pronunciation.HeardLabel': 'Heard as',
    'Pronunciation.OccurrenceMany': '{Count} moments',
    'Pronunciation.OccurrenceOne': '1 moment',
    'Pronunciation.OptionHint': 'For non-native English speakers — spots the words worth practising, with an easy-to-read respelling and IPA. Material to practise, never a score.',
    'Pronunciation.OptionLabel': 'Pronunciation practice',
    'Pronunciation.SayLabel': 'Try',
    'Pronunciation.SectionAria': 'Pronunciation practice',
    'Pronunciation.SectionHeading': 'Pronunciation practice',
    'Quality.BalanceBreakdown': '{Paid} paid · {Monthly} monthly',
    'Quality.BalanceMany': 'Balance: {Balance} credits',
    'Quality.BalanceOne': 'Balance: {Balance} credit',
    'Quality.FrameGroupLabel': 'Body-language detail',
    'Quality.HighCostConfirmLabel': 'Yes — spend up to {Credits} credits on this review',
    'Quality.LoadError': 'Couldn’t load review options.',
    'Quality.LoadingOptions': 'Loading review options…',
    'Quality.ModelGroupLabel': 'Review model',
    'Quality.ModelOptionRecommended': '{Model} — recommended',
    'Quality.NotEnoughCreditsBalance': 'Not enough credits — balance {Balance}.',
    'Quality.RecommendedBadge': 'Recommended',
    'Quality.TierBalanced': 'Balanced',
    'Quality.TierCostMany': '{Credits} credits',
    'Quality.TierCostOne': '{Credits} credit',
    'Quality.TierCustom': 'Custom',
    'Quality.TierDeeper': 'Deeper',
    'Quality.TierDeepest': 'Deepest',
    'Quality.TopUp': 'Top up',
    'Shell.BackToReviews': 'Back to reviews',
    'Shell.CouldNotLoadHeading': 'Couldn’t load review',
    'Shell.FailedToLoad': 'Failed to load review.',
    'Shell.ForbiddenBody': 'You don’t have access to this review.',
    'Shell.Loading': 'Loading review…',
    'Shell.MissingReviewId': 'Missing review id.',
    'Shell.MissingSessionId': 'Missing session id.',
    'Shell.NoReviewYetBody': 'This take hasn’t been sent to AI Review, or its review is still being prepared.',
    'Shell.NoReviewYetHeading': 'No AI Review yet',
    'Shell.NotFoundBody': 'The review you’re looking for doesn’t exist or has been removed.',
    'Shell.NotFoundHeading': 'Review not found',
    'Shell.Running': 'Your AI Review is running',
    'Shell.RunningHint': 'This usually takes under a minute. The page updates itself the moment it’s ready — no need to refresh.',
    'Shell.Title': 'AI Review · VoiceDojo',
    'Shell.TryAgain': 'Try again',
    'Tracks.ArchetypeName': 'Archetype',
    'Tracks.ArchetypeSub': 'detected delivery',
    'Tracks.Aria': 'Review timeline',
    'Tracks.AuditoryAria': 'Auditory chart: pitch, volume and pace over the take, with {Count} pause moments.',
    'Tracks.AuditoryName': 'Auditory',
    'Tracks.AuditorySub': 'pitch · volume · pace · pauses',
    'Tracks.ClarityName': 'Clarity',
    'Tracks.ClaritySub': 'fillers · clutter',
    'Tracks.ContentName': 'Content',
    'Tracks.ContentSub': 'incident · point · VAKS',
    'Tracks.CuesName': 'Cues',
    'Tracks.CuesSub': 'delivered live cues',
    'Tracks.Empty': 'Nothing marked in this take',
    'Tracks.LegendAria': 'Auditory series legend',
    'Tracks.LegendPace': 'Pace',
    'Tracks.LegendPauses': 'Pauses',
    'Tracks.LegendPitch': 'Pitch',
    'Tracks.LegendVolume': 'Volume',
    'Tracks.PronunciationName': 'Pronounce',
    'Tracks.PronunciationSub': 'words to practise',
    'Tracks.Sequence': 'Sequence: {Sequence}',
    'Tracks.TranscriptName': 'Transcript',
    'Tracks.TranscriptSub': 'what was heard',
    'Tracks.VisualName': 'Visual',
    'Tracks.VisualSub': 'posture · gesture · face',
    'Upload.Complete': 'Your AI Review is on its way.',
    'Upload.Failed': 'Upload failed — please try again.',
    'Upload.GetAiReview': 'Get AI Review',
    'Upload.GetAiReviewAria': 'Get an AI Review of this take',
    'Upload.InvalidRequest': 'Invalid upload request.',
    'Upload.NeedCredits': 'You\'re out of AI credits — add credits to run this review.',
    'Upload.NotPermitted': 'Your account can’t run this AI Review right now — see plans and credits.',
    'Upload.Offline': 'You appear to be offline. Please try again when your connection is back.',
    'Upload.PleaseSignIn': 'Please sign in.',
    'Upload.Processing': 'Processing your recording…',
    'Upload.RequestingReview': 'Requesting review…',
    'Upload.RequestingUrl': 'Requesting upload URL…',
    'Upload.ReviewAgain': 'Review again',
    'Upload.ReviewAgainAria': 'Request another AI Review',
    'Upload.ServiceUnavailable': 'Upload service is temporarily unavailable. Please try again later.',
    'Upload.UploadRecording': 'Upload recording',
    'Upload.UploadRecordingAria': 'Upload recording',
    'Upload.Uploading': 'Uploading…',
    'Upload.UploadingRecording': 'Uploading recording…',
  },
  'vi-VN': {
    'Clarity.FillerPerMinute': '{Rate}/phút',
    'Clarity.FillerPhrases': 'Cụm từ đệm ({Count}):',
    'Clarity.FillerTotal': 'Tổng cộng {Count} từ đệm',
    'Clarity.NonWords': 'Tiếng ậm ừ ({Count}):',
    'Clarity.RecognitionConfidenceHelp': 'Mức độ tự tin của bộ nhận dạng giọng nói khi khớp các từ trong lần thu này. Hãy dùng nó để so sánh các lần thu cùng một kịch bản của chính bạn — từ ngữ lạ và giọng vùng miền đều làm nó giảm, nên đây không phải điểm phát âm, điểm giọng hay mức độ dễ hiểu.',
    'Clarity.RecognitionConfidenceLabel': 'Độ tin cậy nhận dạng',
    'Clarity.RecognitionConfidenceShort': 'so sánh các lần thu của chính bạn, không phải điểm số',
    'Dialog.Cancel': 'Huỷ',
    'Dialog.CloseAria': 'Đóng',
    'Dialog.CustomAria': 'Cài đặt đánh giá tùy chỉnh',
    'Dialog.DepthHelpBalanced': 'Cân bằng: đọc kỹ toàn bộ bản thu — lựa chọn cho mỗi ngày.',
    'Dialog.DepthHelpCustom': 'Tùy chỉnh: chọn mô hình đánh giá và mức chi tiết ngôn ngữ cơ thể mà nó xem.',
    'Dialog.DepthHelpDeeper': 'Sâu hơn: một người đánh giá mạnh hơn, nhận ra những điểm tinh tế hơn trong giọng nói và cách trình bày của bạn.',
    'Dialog.DepthHelpDeepest': 'Sâu nhất: người đánh giá giỏi nhất của chúng tôi, dành cho những lần thu quan trọng nhất.',
    'Dialog.DepthLegend': 'Sâu đến đâu?',
    'Dialog.Optional': 'không bắt buộc',
    'Dialog.Request': 'Yêu cầu đánh giá',
    'Dialog.RequestOne': 'Yêu cầu đánh giá · {Credits} tín dụng',
    'Dialog.Subtitle': 'Nhận xét về giọng nói, ngôn ngữ cơ thể, nội dung và độ rõ ràng — không bao giờ chấm điểm.',
    'Dialog.Title': 'Nhận Đánh giá AI',
    'Dialog.YourMix': 'tùy bạn chọn',
    'Discard.Action': 'Xóa đánh giá',
    'Discard.Cancel': 'Hủy',
    'Discard.Confirm': 'Xóa',
    'Discard.ConfirmBody': 'Thao tác này chỉ xóa đánh giá — bản thu và phiên luyện tập của bạn vẫn còn nguyên. Không thể hoàn tác.',
    'Discard.ConfirmTitle': 'Xóa đánh giá AI này?',
    'Discard.Discarded': 'Đã xóa đánh giá.',
    'Discard.Error': 'Không thể xóa đánh giá này. Vui lòng thử lại.',
    'Effort.ChargeNote': 'Bạn trả đúng chi phí thực tế — không bao giờ vượt quá mức tối đa đã hiển thị.',
    'Effort.Help': 'Mức độ mô hình suy nghĩ trước khi trả lời. Nỗ lực cao hơn có thể nhận ra những điều tinh tế hơn và tốn nhiều hơn.',
    'Effort.High': 'Kỹ lưỡng',
    'Effort.Legend': 'Nỗ lực',
    'Effort.Low': 'Nhẹ',
    'Effort.Medium': 'Cẩn thận',
    'Effort.Minimal': 'Nhanh',
    'Effort.RequestUpTo': 'Yêu cầu đánh giá · tối đa {Credits} tín dụng',
    'Effort.Snapped': '{Model} không hỗ trợ mức {Wanted} — đã chọn {Effort}.',
    'FrameworkFit.Heading': 'Mức khớp khung',
    'FrameworkFit.Intro': 'Lần thu này đối chiếu thế nào với các lăng kính bạn đã chọn — là quan sát, không phải điểm số.',
    'Frameworks.LensNudge': 'Tập trung vào một hoặc hai ống kính thường có ích hơn là chọn tất cả — chọn những ống kính phù hợp với lần thu này.',
    'Frameworks.LensPickerAria': 'Ống kính đánh giá khung',
    'Frameworks.LensPickerLegend': 'Ống kính khung',
    'Frameworks.NoneOption': 'Không dùng',
    'Frameworks.OverlayAria': 'Tham khảo khung',
    'Frameworks.ReferenceLabel': 'Tham khảo khung',
    'Library.CouldNotLoadHeading': 'Không thể tải các đánh giá của bạn',
    'Library.DateDaysAgo': '{Days} ngày trước',
    'Library.DateFilterAria': 'Lọc đánh giá theo ngày',
    'Library.DateMonthsAgo': '{Months} tháng trước',
    'Library.DateToday': 'hôm nay',
    'Library.DateWeeksAgo': '{Weeks} tuần trước',
    'Library.DateYesterday': 'hôm qua',
    'Library.EmptyBody': 'Ghi một bản thu ở bất kỳ bài luyện nào — Sân chơi hay Tinh thông — rồi gửi đi để AI đánh giá. Nó sẽ xuất hiện ở đây.',
    'Library.EmptyCta': 'Bắt đầu luyện tập',
    'Library.EmptyHeading': 'Chưa có đánh giá AI nào',
    'Library.FailedToLoad': 'Không tải được các đánh giá của bạn.',
    'Library.FilterAll': 'Tất cả',
    'Library.FilterAnyTime': 'Mọi lúc',
    'Library.FilterAria': 'Lọc đánh giá',
    'Library.FilterLast30Days': '30 ngày qua',
    'Library.FilterLast7Days': '7 ngày qua',
    'Library.FilterPractice': 'Gắn với bài luyện',
    'Library.FilterStandalone': 'Độc lập',
    'Library.FilterToday': 'Hôm nay',
    'Library.Heading': 'Đánh giá AI',
    'Library.Lede': 'Mọi bản thu bạn đã gửi đi để AI đánh giá — phiên luyện tập và bản tải lên độc lập.',
    'Library.Loading': 'Đang tải các đánh giá của bạn…',
    'Library.ManyReviews': '{Count} đánh giá',
    'Library.NoFilterMatch': 'Không có đánh giá nào khớp bộ lọc này.',
    'Library.OneReview': '1 đánh giá',
    'Library.OpenObservatory': 'Mở Đài quan sát',
    'Library.Rereview': 'Đánh giá lại',
    'Library.Retry': 'Đánh giá lại',
    'Library.RetryError': 'Không thể bắt đầu đánh giá lại. Vui lòng thử lại.',
    'Library.SourcePractice': 'Bài luyện',
    'Library.SourceStandalone': 'Bản tải lên độc lập',
    'Library.StatusFailed': 'Thất bại',
    'Library.StatusPending': 'Đang chờ',
    'Library.StatusPrefix': 'Trạng thái: {Status}',
    'Library.StatusReady': 'Sẵn sàng',
    'Library.Title': 'Đánh giá AI của bạn · VoiceDojo',
    'ObservationsPanel.Empty': 'Không có quan sát nào cho lần thu này.',
    'ObservationsPanel.ExpandAll': 'Mở rộng tất cả',
    'ObservationsPanel.Follow': 'Theo bản phát lại',
    'ObservationsPanel.Heading': 'Quan sát',
    'ObservationsPanel.RowAria': 'Quan sát tại {Time}: {Summary}',
    'ObservationsPanel.ShowAll': 'Hiện tất cả quan sát',
    'ObservationsPanel.ShowFewer': 'Thu gọn',
    'Observatory.ConfigAria': 'Cấu hình đánh giá',
    'Observatory.ConfigDepth': 'Độ sâu',
    'Observatory.ConfigLenses': 'Lăng kính',
    'Observatory.ConfigLensesNone': 'Không có',
    'Observatory.FailedNotice': 'Chúng tôi không thể phân tích bản thu này.',
    'Observatory.FrameFull': 'Đầy đủ',
    'Observatory.FrameHalf': '1/2',
    'Observatory.FrameQuarter': '1/4',
    'Observatory.Heading': 'Đài quan sát giọng nói',
    'Observatory.LabelFailed': 'Thất bại',
    'Observatory.LabelNoRecording': 'Không có bản thu',
    'Observatory.LabelPending': 'Đang chờ',
    'Observatory.LabelReviewed': 'Đã đánh giá',
    'Observatory.MoreActions': 'Thao tác khác',
    'Observatory.NoRecordingAria': 'Không có bản thu để phát',
    'Observatory.NoRecordingBody': 'Không có bản thu nào được liên kết với đánh giá này.',
    'Observatory.PendingNotice': 'Đang đánh giá bản thu… AI đang quan sát lần thu của bạn. Trang sẽ tự cập nhật khi hoàn tất.',
    'Observatory.RecordingEvictedNotice': 'Bản thu không còn khả dụng — phân tích giọng nói từ đánh giá này vẫn được lưu bên dưới.',
    'Observatory.Refresh': 'Làm mới',
    'Observatory.SaveAsPdf': 'Lưu thành PDF',
    'Observatory.StatusAria': 'Trạng thái: {Status}',
    'Observatory.SummaryEmpty': 'Không có phần tổng kết nào được tạo cho lần thu này.',
    'Observatory.SummaryHeading': 'Điều nổi bật',
    'Observatory.VoiceAnalyticsUnavailable': 'Phân tích giọng nói không khả dụng cho lần thu này.',
    'Pronunciation.AccentBritishEnglish': 'Tiếng Anh - Anh',
    'Pronunciation.AccentLabel': 'Giọng chuẩn tham chiếu',
    'Pronunciation.AccentUsEnglish': 'Tiếng Anh - Mỹ',
    'Pronunciation.ConfigPronunciation': 'Phát âm',
    'Pronunciation.HeardLabel': 'Nghe thành',
    'Pronunciation.OccurrenceMany': '{Count} khoảnh khắc',
    'Pronunciation.OccurrenceOne': '1 khoảnh khắc',
    'Pronunciation.OptionHint': 'Dành cho người nói tiếng Anh không phải bản ngữ — chỉ ra những từ đáng luyện, kèm phiên âm dễ đọc và IPA. Là tài liệu để luyện tập, không bao giờ là điểm số.',
    'Pronunciation.OptionLabel': 'Luyện phát âm',
    'Pronunciation.SayLabel': 'Thử đọc',
    'Pronunciation.SectionAria': 'Luyện phát âm',
    'Pronunciation.SectionHeading': 'Luyện phát âm',
    'Quality.BalanceBreakdown': '{Paid} đã mua · {Monthly} hàng tháng',
    'Quality.BalanceMany': 'Số dư: {Balance} tín dụng',
    'Quality.BalanceOne': 'Số dư: {Balance} tín dụng',
    'Quality.FrameGroupLabel': 'Chi tiết ngôn ngữ cơ thể',
    'Quality.HighCostConfirmLabel': 'Đồng ý — dùng tối đa {Credits} tín dụng cho bài đánh giá này',
    'Quality.LoadError': 'Không thể tải tùy chọn đánh giá.',
    'Quality.LoadingOptions': 'Đang tải tùy chọn đánh giá…',
    'Quality.ModelGroupLabel': 'Mô hình đánh giá',
    'Quality.ModelOptionRecommended': '{Model} — khuyến nghị',
    'Quality.NotEnoughCreditsBalance': 'Không đủ tín dụng — số dư {Balance}.',
    'Quality.RecommendedBadge': 'Được đề xuất',
    'Quality.TierBalanced': 'Cân bằng',
    'Quality.TierCostMany': '{Credits} tín dụng',
    'Quality.TierCostOne': '{Credits} tín dụng',
    'Quality.TierCustom': 'Tùy chỉnh',
    'Quality.TierDeeper': 'Sâu hơn',
    'Quality.TierDeepest': 'Sâu nhất',
    'Quality.TopUp': 'Nạp thêm',
    'Shell.BackToReviews': 'Quay lại danh sách đánh giá',
    'Shell.CouldNotLoadHeading': 'Không thể tải đánh giá',
    'Shell.FailedToLoad': 'Không tải được đánh giá.',
    'Shell.ForbiddenBody': 'Bạn không có quyền truy cập đánh giá này.',
    'Shell.Loading': 'Đang tải đánh giá…',
    'Shell.MissingReviewId': 'Thiếu mã đánh giá.',
    'Shell.MissingSessionId': 'Thiếu mã phiên.',
    'Shell.NoReviewYetBody': 'Bản thu này chưa được gửi đi để AI đánh giá, hoặc đánh giá vẫn đang được chuẩn bị.',
    'Shell.NoReviewYetHeading': 'Chưa có đánh giá AI',
    'Shell.NotFoundBody': 'Đánh giá bạn đang tìm không tồn tại hoặc đã bị xóa.',
    'Shell.NotFoundHeading': 'Không tìm thấy đánh giá',
    'Shell.Running': 'Đánh giá AI của bạn đang chạy',
    'Shell.RunningHint': 'Quá trình này thường mất chưa đến một phút. Trang sẽ tự cập nhật ngay khi sẵn sàng — không cần tải lại.',
    'Shell.Title': 'Đánh giá AI · VoiceDojo',
    'Shell.TryAgain': 'Thử lại',
    'Tracks.ArchetypeName': 'Nguyên mẫu',
    'Tracks.ArchetypeSub': 'cách thể hiện được nhận ra',
    'Tracks.Aria': 'Dòng thời gian đánh giá',
    'Tracks.AuditoryAria': 'Biểu đồ âm thanh: cao độ, âm lượng và tốc độ trong suốt lần thu, với {Count} lần ngắt nghỉ.',
    'Tracks.AuditoryName': 'Âm thanh',
    'Tracks.AuditorySub': 'cao độ · âm lượng · tốc độ · ngắt nghỉ',
    'Tracks.ClarityName': 'Độ rõ ràng',
    'Tracks.ClaritySub': 'từ đệm · tạp âm',
    'Tracks.ContentName': 'Nội dung',
    'Tracks.ContentSub': 'sự việc · ý chính · VAKS',
    'Tracks.CuesName': 'Gợi ý',
    'Tracks.CuesSub': 'gợi ý trực tiếp đã phát',
    'Tracks.Empty': 'Không có gì được đánh dấu trong lần thu này',
    'Tracks.LegendAria': 'Chú thích các chuỗi âm thanh',
    'Tracks.LegendPace': 'Tốc độ',
    'Tracks.LegendPauses': 'Ngắt nghỉ',
    'Tracks.LegendPitch': 'Cao độ',
    'Tracks.LegendVolume': 'Âm lượng',
    'Tracks.PronunciationName': 'Phát âm',
    'Tracks.PronunciationSub': 'từ nên luyện',
    'Tracks.Sequence': 'Trình tự: {Sequence}',
    'Tracks.TranscriptName': 'Lời thoại',
    'Tracks.TranscriptSub': 'những gì được nghe',
    'Tracks.VisualName': 'Hình ảnh',
    'Tracks.VisualSub': 'tư thế · cử chỉ · nét mặt',
    'Upload.Complete': 'Đánh giá AI của bạn đang được chuẩn bị.',
    'Upload.Failed': 'Tải lên thất bại — vui lòng thử lại.',
    'Upload.GetAiReview': 'Nhận Đánh giá AI',
    'Upload.GetAiReviewAria': 'Nhận Đánh giá AI cho bản thu này',
    'Upload.InvalidRequest': 'Yêu cầu tải lên không hợp lệ.',
    'Upload.NeedCredits': 'Bạn đã hết tín dụng AI — hãy thêm tín dụng để chạy đánh giá này.',
    'Upload.NotPermitted': 'Tài khoản của bạn hiện không chạy được Đánh giá AI này — xem gói và tín dụng.',
    'Upload.Offline': 'Bạn đang ngoại tuyến. Vui lòng thử lại khi có kết nối.',
    'Upload.PleaseSignIn': 'Vui lòng đăng nhập.',
    'Upload.Processing': 'Đang xử lý bản ghi của bạn…',
    'Upload.RequestingReview': 'Đang yêu cầu đánh giá…',
    'Upload.RequestingUrl': 'Đang lấy đường dẫn tải lên…',
    'Upload.ReviewAgain': 'Đánh giá lại',
    'Upload.ReviewAgainAria': 'Yêu cầu thêm đánh giá AI',
    'Upload.ServiceUnavailable': 'Dịch vụ tải lên tạm thời không khả dụng. Vui lòng thử lại sau.',
    'Upload.UploadRecording': 'Tải lên bản thu',
    'Upload.UploadRecordingAria': 'Tải lên bản thu',
    'Upload.Uploading': 'Đang tải lên…',
    'Upload.UploadingRecording': 'Đang tải bản ghi lên…',
  },
} as const;

